class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      console.log({deb:event})
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    // facetForm.addEventListener('blur', this.debouncedOnSubmit.bind(this));    

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.create_price_slider();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }
  console.log({sections})
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

       // var stepsSlider = document.getElementById('steps-slider');
       //  stepsSlider.noUiSlider.reset()

      // create_price_slider();

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    console.log({facet_log:url, event})
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        create_price_slider();
      });
  }

  create_price_slider() {
  if ($("#steps-slider").length > 0) {

     const params = window.location.href.indexOf('?') == -1 ? '' : window.location.href.slice(window.location.href.indexOf('?') + 1);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const newParams = Object.fromEntries(urlSearchParams.entries());
    console.log({newParams})
    
    var stepsSlider = document.getElementById('steps-slider');
    var input0 = document.getElementById('Filter-Price-GTE');
    var input1 = document.getElementById('Filter-Price-LTE');
    var inputs = [input0, input1];
    var max_price_range = parseFloat(input1.getAttribute("placeholder"))
      
    noUiSlider.create(stepsSlider, {
      start: [+newParams['filter.v.price.gte'] || 0.00, +newParams['filter.v.price.lte'] || max_price_range],
      connect: true,
      range: {
          'min': 0.00,
          'max': max_price_range
      }
    });
   
    this.price_slider_update(inputs, stepsSlider, params);
}
}

  price_slider_update(inputs, stepsSlider, params) {
    stepsSlider.noUiSlider.on('set', function (values, handle) {
      inputs[handle].value = values[handle];

        let finalVal = {
        value: inputs[handle].value,
        min: values[0],
        max: values[1]
      }

      $("#Filter-Price-GTE").attr("min", finalVal.min);
      $("#Filter-Price-LTE").attr("max", finalVal.max);
      $(inputs[handle]).attr("value", finalVal.value);
      $('#FacetFiltersForm').submit();
    });
}

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    console.log({searchParams})
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    console.log({stat:document.getElementById('product-grid').dataset.id,})
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    console.log({event})
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
        
    // if ($("#steps-slider").length > 0) {
    // var stepsSlider = document.getElementById('steps-slider');
    // var input0 = document.getElementById('Filter-Price-GTE');
    // var input1 = document.getElementById('Filter-Price-LTE');
    // var inputs = [input0, input1];
    //   console.log("SLIDER",{stepsSlider})

    //   console.log({inputs})
    
    // noUiSlider.create(stepsSlider, {
    //   start: [0, 30.95],
    //   connect: true,
    //   range: {
    //       'min': 0 ,
    //       'max': 30.95
    //   }
    // });
    
    // stepsSlider.noUiSlider.on('update', this.sliderUpdate.bind(this, inputs))
    // }
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    console.log({event, target:event.currentTarget})
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }
  
    // sliderUpdate(inputs, values, handle) {
    //   // console.log({values, handle, inputs})
    //   inputs[handle].value = values[handle];

    //       console.log({values, handle, handleVal:inputs[handle].value, handle:inputs[handle]})

    //   let finalVal = {
    //     value: Number(inputs[handle].value),
    //     min: Number(values[0]),
    //     max: Number(values[1])
    //   }

    //   console.log({finalVal});

    //  // this.onRangeChange();

    //   this.debouncedOnSubmit = debounce((event) => {
    //   console.log({deb:event})
    //   FacetFiltersForm.onSubmitHandler(event);
    // }, 500);

    //   const facetForm = document.querySelector('#FacetFiltersForm');

    //    const urlSearchParams = new URLSearchParams(facetForm.action);
    // const newParams = Object.fromEntries(urlSearchParams.entries());

    //   const params = window.location.href.indexOf('?') == -1 ? '' : window.location.href.slice(window.location.href.indexOf('?') + 1);
    //   console.log({params})

    
      
    //   console.log({facetForm:facetForm.action})
      
     

    //   console.log({newParams})
      
    //   facetForm.action = `${window.location.pathname}${params && '?'.concat(params)}`;
    // console.log({params})
    //   facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    //   this.adjustToValidValues(inputs[handle], finalVal);
    //   this.setMinAndMaxValues();
    // }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input, values = {}) {
    console.log({'=========> ': input, values})
    let value = 0;
    let min = 0;
    let max = 0;
    if (input) {
      value = Number(input.value);
      min = Number(input.getAttribute('min'));
      max = Number(input.getAttribute('max'));
    } else {
      value = Number(values.value);
        min = Number(values.min);
       max = Number(values.max);
    }

    if (value < min) input.value = min;
    if (value > max) input.value = max;
   
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    $("#itemsPerPage").change();
    console.log("changed1");
  }
}

customElements.define('facet-remove', FacetRemove);
